var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 17.6803C14.2419 17.6803 17.6803 14.2419 17.6803 10.0003C17.6803 5.75877 14.2419 2.32031 10.0003 2.32031C5.75877 2.32031 2.32031 5.75877 2.32031 10.0003C2.32031 14.2419 5.75877 17.6803 10.0003 17.6803ZM8.75914 7.40149C8.38423 7.02659 7.77639 7.02659 7.40149 7.40149C7.02659 7.77639 7.02659 8.38423 7.40149 8.75914L8.64267 10.0003L7.40149 11.2415C7.02659 11.6164 7.02659 12.2242 7.40149 12.5991C7.77639 12.974 8.38423 12.974 8.75914 12.5991L10.0003 11.358L11.2415 12.5991C11.6164 12.974 12.2242 12.974 12.5991 12.5991C12.974 12.2242 12.974 11.6164 12.5991 11.2415L11.358 10.0003L12.5991 8.75914C12.974 8.38423 12.974 7.77639 12.5991 7.40149C12.2242 7.02659 11.6164 7.02659 11.2415 7.40149L10.0003 8.64267L8.75914 7.40149Z",
    fill: "#F31260"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedButtonIcon);
export default __webpack_public_path__ + "static/media/rejected_button_icon.bd2bcbdb8f89a910f9356758ea9451e7.svg";
export { ForwardRef as ReactComponent };